import Brand from "@/components/Brand";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <Brand size={36} showText={true} asLink={false} testId="footer-brand" />
        <div className="text-xs text-slate-500 max-w-md leading-relaxed">
          We are not attorneys and do not provide legal advice. We help Veterans understand
          and organize their claim opportunities under VA policy. © {new Date().getFullYear()} For Those Who Served.
        </div>
      </div>
    </footer>
  );
}
